// Feature flags — read from localStorage, with env-var defaults.
// Convention: VITE_FF_<NAME>=true|false sets the default; localStorage key
// "nimblenode_ff_<name>" overrides at runtime for any user.

const DEFAULT_FLAGS = {
  // GUIDE_ASSISTANT: default ON during testing phase.
  // Set VITE_FF_GUIDE_ASSISTANT=false in .env.local to turn off globally.
  // Set localStorage key nimblenode_ff_guide_assistant=false to hide for one user.
  guide_assistant: import.meta.env.VITE_FF_GUIDE_ASSISTANT !== 'false',
};

function readFlag(name) {
  const lsKey = `nimblenode_ff_${name}`;
  try {
    // localStorage throws in Safari Private Mode / when cookies are blocked.
    // flags are read during shell render (above PageErrorBoundary) — never throw.
    const lsVal = localStorage.getItem(lsKey);
    if (lsVal === 'true') return true;
    if (lsVal === 'false') return false;
  } catch { /* storage blocked — fall back to default */ }
  return DEFAULT_FLAGS[name] ?? false;
}

export const flags = {
  guideAssistant: () => readFlag('guide_assistant'),
};
